import { borderColor, brandPrimaryHover, white } from '@Styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	actionContainer: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	automationContainer: {
		width: '35%',
	},
	automationName: {
		color: brandPrimaryHover,
		fontSize: 18,
		marginBottom: 0,
		marginTop: 45,
	},
	checkbox: {
		fontSize: 14,
		marginLeft: 11,
	},
	contactList: {
		border: '1px solid #C5DCEC',
		margin: '20px 0',
		maxHeight: 330,
		overflowY: 'auto',
		position: 'relative',
	},
	contactListContainer: {
		width: '55%',
	},
	contactListItem: {
		background: white,
	},
	container: {
		':last-child': {
			borderBottom: 'none',
		},
		borderBottom: `1px solid ${borderColor}`,
		display: 'flex',
		justifyContent: 'space-between',
		padding: 20,
	},
	disableScroll: {
		overflowY: 'hidden',
	},
	selectTrigger: {
		width: 160,
	},
	employeeSearch: {
		boxSizing: 'border-box',
		overFlow: 'hidden',
	},
	opacity: {
		cursor: 'initial',
		opacity: 0.4,
	},
	sendFromFieldWrap: {
		alignItems: 'center',
		display: 'flex',
		marginTop: 10,
		width: '100%',
	},
	sendFromLabel: {
		color: '#A7ABAD',
		fontSize: 12,
		marginRight: 10,
		minWidth: 62,
	},
	stepsLabel: {
		marginBottom: 7,
		marginTop: 10,
	},
	stepsOverflowLabel: {
		color: '#AAAAAA',
		fontSize: 11,
	},
	successCover: {
		alignItems: 'center',
		background: `rgba(255,255,255, 0.6)`,
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		left: 0,
		position: 'absolute',
		top: 0,
		width: '100%',
	},
});
